var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.highEndTipsInfo.text)?_c('div',{staticClass:"box"},[_c('div',{staticClass:"text-box"},[_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.highEndTipsInfo.text))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }